import { PRT_DETAIL_ACTIONS as PDA } from 'actions/protocols/protocoldetail';
import { VERSION_ACTIONS as VRA } from 'actions/protocols/version';
import { STUDY_AGENT_ACTIONS as SAA } from 'actions/protocols/studyagents';
import { CIRB_ACTIONS as CIA } from 'actions/protocols/cirb';
import { PRT_INTEGRATIONS_ACTIONS as PIA } from 'actions/protocols/integrations';
import { PRT_ACTIONS as PRA } from 'actions/protocols';
import { OPEN_SETUP_ACTIONS as OSA } from 'actions/protocols/opensetup';
import { PARTICIPATION_ACTIONS as PAA } from 'actions/protocols/participation';
import { PSRS_ACTIONS as PSRA } from 'actions/protocols/psrs';
import { PRT_FUNDING_ACTIONS as PFA } from 'actions/protocols/funding';
import {
  protocolState,
  protocolDetailState,
  versionsState,
  studyAgentsState,
  cirbState,
  integrationsState,
  openState,
  participationState,
  psrsState,
  fundingState
} from 'models/protocols';
import { suffixFulfilled, suffixPending } from 'actions';

export const setProtocol = PRA.SET_PROTOCOL;
export const setProtocolTab = PRA.SET_PROTOCOL_TAB;
export const getProtocolsFulfilled = PRA.GET_PROTOCOLS + suffixFulfilled;
export const getProtDetailsPending = PDA.GET_PROT_DETAILS + suffixPending;
export const getProtDetailsFulfilled = PDA.GET_PROT_DETAILS + suffixFulfilled;
export const getProtocolStatusHistoryPending = PDA.GET_PROT_STATUS_HIST + suffixPending;
export const getProtocolStatusHistoryFulfilled = PDA.GET_PROT_STATUS_HIST + suffixFulfilled;
export const getProtCohortDataFulfilled = PDA.GET_COHORTS+suffixFulfilled;
export const getProtCohortDataPending = PDA.GET_COHORTS+suffixPending;
export const getProtCohortDataArmFulfilled = PDA.GET_ARM_COHORTS+suffixFulfilled;
export const getProtCohortDataArmPending = PDA.GET_ARM_COHORTS+suffixPending;
export const getCohortHistoryFulfilled = PDA.GET_COHORT_HISTORY+suffixFulfilled;
export const getCohortHistoryPending = PDA.GET_COHORT_HISTORY+suffixPending;
export const getStrataHistoryFulfilled = PDA.GET_STRATA_HISTORY +suffixFulfilled;
export const getStrataHistoryPending = PDA.GET_STRATA_HISTORY+suffixPending;

export const getVersionsPending = VRA.GET_VERSIONS + suffixPending;
export const getVersionsFulfilled = VRA.GET_VERSIONS + suffixFulfilled;
export const getPioVersionsPending = VRA.GET_PIO_VERSIONS + suffixPending;
export const getPioVersionsFulfilled = VRA.GET_PIO_VERSIONS + suffixFulfilled;

export const getCtepStudyAgentsPending = SAA.GET_CTEP_STUDY_AGENTS + suffixPending;
export const getCtepStudyAgentsFulfilled = SAA.GET_CTEP_STUDY_AGENTS + suffixFulfilled;
export const getNonCtepAgentsPending = SAA.GET_NON_CTEP_STUDY_AGENTS + suffixPending;
export const getNonCtepAgentsFulfilled = SAA.GET_NON_CTEP_STUDY_AGENTS + suffixFulfilled;

export const getIntegrationsPending = PIA.GET_PROT_INTEGRATIONS + suffixPending;
export const getIntegrationsFulfilled = PIA.GET_PROT_INTEGRATIONS + suffixFulfilled;
export const getStartInfoPending = PIA.GET_PROT_START_INFO + suffixPending;
export const getStartInfoFulfilled = PIA.GET_PROT_START_INFO + suffixFulfilled;

export const getFundingPending = PFA.GET_PROT_FUNDINGS + suffixPending;
export const getFundingFulfilled = PFA.GET_PROT_FUNDINGS + suffixFulfilled;


export const getParticipationPending = PAA.GET_PARTICIPATION + suffixPending;
export const getParticipationFulfilled = PAA.GET_PARTICIPATION + suffixFulfilled;
export const getParticipationCountriesPending = PAA.GET_COUNTRIES + suffixPending;
export const getParticipationCountriesFulfilled = PAA.GET_COUNTRIES + suffixFulfilled;
export const getChampionsCountriesPending = PAA.GET_CHAMPIONS + suffixPending;
export const getChampionsCountriesFulfilled = PAA.GET_CHAMPIONS + suffixFulfilled;

export const getPSRsPending = PSRA.GET_PSRS + suffixPending;
export const getPSRsFulfilled = PSRA.GET_PSRS + suffixFulfilled;
export const getPSRsSplReqAffiPending = PSRA.GET_PSRS_AFFILIATION + suffixPending;
export const getPSRsSplReqAffiFulfilled = PSRA.GET_PSRS_AFFILIATION + suffixFulfilled;
export const getPSRsAffiliationsHistoryPending = PSRA.GET_AFFILIATIONS_HISTORY + suffixPending;
export const getPSRsAffiliationsHistoryFulfilled = PSRA.GET_AFFILIATIONS_HISTORY + suffixFulfilled;

export const getCIRBEventDocsPending = CIA.GET_EVENT_DOCS + suffixPending;
export const getCIRBEventDocsFulfilled = CIA.GET_EVENT_DOCS + suffixFulfilled;

export const getOpenSetupPending = OSA?.GET_OPENSETUP + suffixPending;
export const getOpenSetupFulfilled = OSA?.GET_OPENSETUP + suffixFulfilled;
export const getOpenRelationsPending = OSA?.GET_RELATIONS + suffixPending;
export const getOpenRelationsFulfilled = OSA?.GET_RELATIONS + suffixFulfilled;
export const getOpenEmbeddedPending = OSA?.GET_EMBEDDED + suffixPending;
export const getOpenEmbeddedFulfilled = OSA?.GET_EMBEDDED + suffixFulfilled;

export const ProtocolReducer = (
  state,
  action: { type: string, payload: {} }
) => {
  if (typeof state === 'undefined') {
    return protocolState;
  }
  switch (action.type) {
    case setProtocol:
      return {
        ...state,
        selProtocol: action.payload
      };
    case setProtocolTab:
      return {
        ...state,
        selPrtTab: action.payload
      };
    case getProtocolsFulfilled:
      return {
        ...state,
        protocols: { ...state.protocols, ...action.payload }
      };
    default:
      return state;
  }
};

export const ProtocolDetailReducer = (
  state,
  action: { type: string, payload: {} }
) => {
  if (typeof state === 'undefined') {
    return protocolDetailState;
  }
  switch (action.type) {
    case getProtDetailsPending:
      return { ...state, prtInfo: {} };
    case getProtDetailsFulfilled:
      return { ...state, prtInfo: { ...state.prtInfo, ...action.payload } };
    case getProtocolStatusHistoryPending:
      return {
        ...state,
        prtStatusChangeHist: []
      };
    case getProtocolStatusHistoryFulfilled:
      return {
        ...state,
        prtStatusChangeHist: action.payload
      };
    case getProtCohortDataFulfilled:
      return {...state, cohortData:action.payload}
    case getProtCohortDataPending:
      return {...state, cohortData:[]}
    case getProtCohortDataArmFulfilled:
      return {...state, cohortsArmData:action.payload}
    case getProtCohortDataArmPending:
      return {...state, cohortsArmData:[]}
    case getCohortHistoryFulfilled:
      return {...state, cohortHistory: action.payload}
    case getCohortHistoryPending:
      return {...state, cohortHistory:[]}
    case getStrataHistoryFulfilled:
      return {...state, strataHistory:action.payload}
    case getStrataHistoryPending:
      return {...state, strataHistory:[]}
    default:
      return state;
  }
};

export const VersionReducer = (
  state,
  action: { type: string, payload: {} }
) => {
  if (typeof state === 'undefined') {
    return versionsState;
  }
  switch (action.type) {
    case getVersionsPending:
      return {
        ...state,
        localVersions: {}
      };
    case getVersionsFulfilled:
      return {
        ...state,
        localVersions: action.payload
      };
    case getPioVersionsPending: {
      return { ...state, pioVersions: {} };
    }
    case getPioVersionsFulfilled: {
      return {
        ...state,
        pioVersions: action.payload
      };
    }
    default:
      return state;
  }
};

export const StudyAgentsReducer = (
  state,
  action: { type: string, payload: {} }
) => {
  if (typeof state === 'undefined') {
    return studyAgentsState;
  }
  switch (action.type) {
    case getCtepStudyAgentsPending:
      return { ...state, ctepStudyAgents: {} };
    case getCtepStudyAgentsFulfilled:
      return {
        ...state,
        ctepStudyAgents: action.payload
      };
    case getNonCtepAgentsPending:
      return { ...state, nonCTEP: {} };
    case getNonCtepAgentsFulfilled:
      return {
        ...state,
        nonCTEP: action.payload
      };
    default:
      return state;
  }
};

export const CirbReducer = (
  state,
  action: { type: string, payload: {} }
) => {
  if (typeof state === 'undefined') {
    return cirbState;
  }
  switch (action.type) {
    case getCIRBEventDocsPending:
      return { ...state, eventDocs: {} };
    case getCIRBEventDocsFulfilled:
      return {
        ...state,
        eventDocs: action.payload
      };
    default:
      return state;
  }
};

export const ParticipationReducer = (
  state,
  action: { type: string, payload: {} }
) => {
  if (typeof state === 'undefined') {
    return participationState;
  }
  switch (action.type) {
    case getParticipationPending:
      return { ...state, participationInfo: {} };
    case getParticipationFulfilled:
      return {
        ...state,
        participationInfo: action.payload
      };
    case getParticipationCountriesPending:
      return { ...state, countries: {} };
    case getParticipationCountriesFulfilled:
      return {
        ...state,
        countries: action.payload
      };
    case getChampionsCountriesPending:
      return { ...state, studyChampions: {} };
    case getChampionsCountriesFulfilled:
      return {
        ...state,
        studyChampions: action.payload
      };
    default:
      return state;
  }
};

export const IntegrationsReducer = (
  state,
  action: { type: string, payload: {} }
) => {
  if (typeof state === 'undefined') {
    return integrationsState;
  }
  switch (action.type) {
    case getIntegrationsPending:
      return { ...state, integrationInfo: {} };
    case getIntegrationsFulfilled:
      return {
        ...state,
        integrationInfo: action.payload
      };
    case getStartInfoPending:
      return { ...state, startInfo: {} };
    case getStartInfoFulfilled:
      return {
        ...state,
        startInfo: action.payload
      };
    default:
      return state;
  }
};

export const FundingReducer = (
  state,
  action: { type: string, payload: {} }
) => {
  if (typeof state === 'undefined') {
    return fundingState;
  }
  switch (action.type) {
    case getFundingPending:
      return { ...state, fundings: {} };
    case getFundingFulfilled:
      return { ...state, fundings: action.payload };
    case PFA.SET_PROT_FUNDING_INDEX:
      return { ...state, fundingIndex: action.payload };
    case PFA.SET_SELECTED_FUNDING_ID:
      return { ...state, fundingId: action.payload };
    default:
      return state;
  }
};

export const OpenReducer = (
  state,
  action: { type: string, payload: {} }
) => {
  if (typeof state === 'undefined') {
    return openState;
  }
  switch (action.type) {
    case getOpenSetupPending:
      return { ...state, openData: {} };
    case getOpenSetupFulfilled:
      return {
        ...state,
        openData: action.payload
      };
    case getOpenRelationsPending:
      return { ...state, relations: {} };
    case getOpenRelationsFulfilled:
      return {
        ...state,
        relations: action.payload
      };
    case getOpenEmbeddedPending:
      return { ...state, embedded: {} };
    case getOpenEmbeddedFulfilled:
      return {
        ...state,
        embedded: action.payload
      };
    case OSA.SET_REG_STEP_INDEX:
      return { ...state, regStepindex: action.payload };
    default:
      return state;
  }
};

export const PSRsReducer = (
  state,
  action: { type: string, payload: {} }
) => {
  if (typeof state === 'undefined') {
    return psrsState;
  }
  switch (action.type) {
    case getPSRsPending:
      return { ...state, psrInfo: {} };
    case getPSRsFulfilled:
      return { ...state, psrInfo: action.payload };
    case getPSRsSplReqAffiPending:
      return { ...state, psrSplReqAffi: {} };
    case getPSRsSplReqAffiFulfilled:
      return { ...state, psrSplReqAffi: action.payload };
    case PSRA.SET_PSR_INDEX:
      return { ...state, psrIndex: action.payload };
    case getPSRsAffiliationsHistoryFulfilled:
      return { ...state, affiliationsHistory: action.payload };
    case PSRA.SET_SELECTED_PSR:
      return { ...state, selectedPsr: action.payload };
    default:
      return state;
  }
};
